import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('projects');
const type = createActionType('projects');

export const LOAD_PROJECTS = apiType('LoadProjects');
export const LOAD_PROJECT = apiType('LoadProject');
export const SET_CURRENT_ENTITY = type('SetCurrentEntity');

export const OPEN_CREATE_PROJECT_DIALOG = type('OpenCreateProjectDialog');
export const CLOSE_CREATE_PROJECT_DIALOG = type('CloseCreateProjectDialog');
export const TOGGLE_CREATE_PROJECT_DIALOG = type('ToggleCreateProjectDialog');
export const CREATE_PROJECT = apiType('CreateProject');

export const CLONE_PROJECT = apiType('CloneProject');
export const LOAD_CURRENT_PROJECT = type('LoadCurrentProject');

export const SYNC_PROJECT = apiType('SyncProject');

export const SELECT_TABLE = type('SelectTable');

export const LOAD_UPSTREAM_DATASOURCES = apiType('LoadUpstreamDatasources');

export const GET_PROJECT_INPUTS = apiType('GetProjectInputs');

export const UPDATE_PROJECT_ENV_ACTION_TYPE = apiType('UpdateProjectEnv');
